import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useAlert } from 'react-alert';
import ReactPaginate from "react-paginate";
import { handleSortBy, getLastURL, ImageUrl, numberWithCommas, CompanyNameDisplay, RatingDisplay, ProductTitleDisplayColorStone } from '../../../helper';
import { url, postPerPage } from '../../../config';
import { IMAGES, SEARCH_LIMIT_MSG } from '../../../constants';
import { useHistory } from 'react-router';
import $ from 'jquery';
import { colorstoneJson } from '../../../utils/json';
import { getAllProductsFilter, GetProductCount } from '../../../actions/productActions';
import { useLocation } from 'react-router';
import { getProductsFilterByAscending, AddFavoriteProduct, getAllProducts } from '../../../actions/productActions';
import PopupConfirm from '../../layout/PopupConfirm';
import mixpanel from 'mixpanel-browser';
import { FormattedMessage, useIntl } from 'react-intl';
import { comaSeperatedFilter } from '../../../helper';

const ColorStone = (props) => {

    const alert = useAlert();
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const [activeFilters, setActiveFilters] = useState([]);

    const { products, error, loading } = useSelector(state => state.products);
    const { user } = useSelector(state => state.user);

    const [postsPerPage] = useState(postPerPage);
    const [filterdisplayname, setFilterDisplayName] = useState(<FormattedMessage id="Select Sort Option" />);
    const [search, setSearch] = useState()

    const category_slug = getLastURL(location);

    const [popUpLimitTitle] = useState(<FormattedMessage id="Search Limit Finished" />);
    const [popUpLimitMessage] = useState(SEARCH_LIMIT_MSG);

    useEffect(() => {
        if (error) {
            alert.error(error);
            return;
        }
    }, [alert, error])

    const handleResForm = (status) => {
        if (status) {
            $("#dismiss-modal").trigger('click');
            history.push({ pathname: url + '/plan-details' });
        }
    }
    const handlePageChange = ({ selected }) => {
        props.updateResetPageHandler(selected)
        dispatch(getAllProducts(category_slug, (selected + 1)));
    }

    const pageCount = Math.ceil((products && products.products && products.products.total) / postsPerPage);

    const handleAcendingFilter = (value, type, displayname) => {
        setFilterDisplayName(displayname)
        $('.sort_by_list').css({
            display: "none"
        })
        props.tabChangeHandler(1)
        dispatch(getProductsFilterByAscending(category_slug, value, type))
    }

    const handleSearch = (e) => {
        setSearch(e.target.value);
    }


    const handleSearchFilter = (e) => {
        mixpanel.track('Search ColorStone')
        if (e.key === 'Enter') {
            dispatch(getAllProductsFilter(category_slug, { search: search }));
        }
    }

    const handleSearchIconClick = () => {
        mixpanel.track('Search ColorStone');
        dispatch(getAllProductsFilter(category_slug, { search: search }));
    };



    const handleAddFavorite = async (product_id) => {

        if ($('.heart.checkheart_' + product_id).hasClass('active')) {
            $('.heart.checkheart_' + product_id).removeClass('active');
        } else {
            $('.heart.checkheart_' + product_id).addClass('active');
        }

        await dispatch(AddFavoriteProduct(product_id));
        dispatch(GetProductCount());
    }
    products && products.over_limit &&
        $("#popup-click-confirm").trigger('click')

    const handleFilter = (keyToRemove) => {

        const updatedFilter = Object.entries(activeFilters).filter(([key]) => key !== keyToRemove).reduce((acc, [key, value]) => {
            if(key === 'sieve' || key === 'carat' || key === 'price' || key === 'measurement') {
                        acc[key] = value;
                        return acc;
            }
            acc[key] = value.map(item => item.attribute_id);
            return acc;
        }, {})

        setActiveFilters(updatedFilter);
        dispatch(getAllProductsFilter(category_slug, updatedFilter));
    };


    useEffect(() => {
        if (products?.filter && Object.keys(products?.filter).length > 0) {
            setActiveFilters(products?.filter)
        }
    }, [products?.filter])




    return (
        <Fragment>
            <div className="col-lg-12">
                <div className="dashboard-content">
                    <div className="filter_search_right">
                        <div className="search_cat_top">
                            <div className="row">
                                <div className="col-lg-8 col-md-8 col-sm-8">
                                    <button className='all-filters-btn' onClick={() => { props?.setShowFilters(!props?.showFilters) }} type='button'><img src={IMAGES.filterIcon} alt="filter-icon" loading="lazy" />
                                        <FormattedMessage
                                            id="addsingleproduct.all-filters"
                                            defaultMessage="All Filters"
                                        />
                                    </button>
                                    <div className="s_c">
                                        {
                                            //Kartik's code
                                            products?.filter && Object.entries(products?.filter)?.map(([filterName, filterArr]) => {
                                                
                                                if (filterName == 'type') {
                                                        return
                                                      }
                                                if(filterName == 'carat' || filterName == 'measurement' || filterName == 'price' || filterName == 'sieve'){
                                                    return (
                                                    <div className="s_c" key={filterName}>
                                                            <p style={{marginLeft:'10px'}}>
                                                                <span className='first-letter'>
                                                                    <b>{filterName}</b> {filterArr?.from ? filterArr?.from : filterArr?.length} - {filterArr?.to ? filterArr?.to : filterArr?.width}
                                                                </span>
                                                                <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(filterName)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                                return (
                                                    <div className="s_c" key={filterName}>
                                                        <p style={{ marginLeft: '10px' }}>
                                                            <span className='first-letter'>
                                                                {filterName}: {Array.isArray(filterArr) ? comaSeperatedFilter(filterArr) : filterArr}
                                                            </span>
                                                            <button
                                                                className='text-black border-0 p-0 bg-none ml-3'
                                                                style={{ outline: 'none' }}
                                                                onClick={() => handleFilter(filterName)}
                                                            >
                                                                <i className='icon-close_1 ml-0'></i>
                                                            </button>
                                                        </p>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4">
                                    <div className="form-group sort_by_box">
                                        <p className="sort_b_h" onClick={handleSortBy}><b><FormattedMessage id="Sort_By" defaultMessage="Sort By" />:</b>  {filterdisplayname} <span className="icon-chevron_down"></span></p>
                                        <div className="sort_by_list">
                                            <ul>
                                                {
                                                    colorstoneJson && colorstoneJson.map((data, key) => {
                                                        return (
                                                            <li className="activess" onClick={() => handleAcendingFilter(data.value, data.type, data.display_name)} key={key}>{data.display_name}</li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {loading ? <div className="loader-line"></div> : ""}
                        <div className="form-group seach_filter row justify-content-end">
                            <div className="col-xl-8 col-lg-6 col-md-6 col-sm-6">
                                <div className="re_text">
                                    <h4 className="font-16 black-3B fb"><FormattedMessage id="Results" defaultMessage="Results" /></h4>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                <div className='position-relative'>
                                    <input type="text" value={search} onKeyPress={(e) => handleSearchFilter(e)} onChange={handleSearch} className="form-control" placeholder={useIntl().formatMessage({ id: 'SearchBySeller' })} />
                                    <span className="icon-search_1  input_icon" onClick={handleSearchIconClick} style={{ cursor: 'pointer' }}></span>
                                </div>
                            </div>
                        </div>
                        <div className="product_card">
                            <div className="row">
                                {products && products?.products && products?.products?.data?.length > 0 ?
                                    products && products?.products && products?.products?.data && products?.products?.data.map((watch, key) => {
                                        return (
                                            <div className="col-md-3 col-sm-3" key={key}>
                                                <div className="card_1 on">
                                                    {Number(watch?.seller_id) !== Number(user?.id) ?
                                                        <span style={{ cursor: 'pointer' }} onClick={() => handleAddFavorite(watch.id)}><i className={watch.is_favourite > 0 ? "fa fa-heart active heart checkheart_" + watch.id : "fa fa-heart heart checkheart_" + watch.id}></i></span> : ""}
                                                    <Link to={url + `/details/color-stones/${watch.id}`} target="_blank" className="not_a">
                                                        <div className="card_img">
                                                            <img
                                                                src=
                                                                {watch && watch.single_image ?
                                                                    watch && watch?.single_image && ImageUrl(watch.single_image.file)
                                                                    :
                                                                    watch && ImageUrl(watch.single_image)
                                                                }
                                                                alt="" loading="lazy" />
                                                        </div>
                                                    </Link>
                                                    <Link to={url + `/details/color-stones/${watch.id}`} target="_blank" className="not_a">
                                                        <div className="card_details" style={{ cursor: "pointer" }}>
                                                            <p className="font-14 black-3B fm mb-2">
                                                                {/* <h5>{watch && ProductTitleDisplay('cs', watch.productDetails = watch)}</h5> */}
                                                                <h5>{watch && ProductTitleDisplayColorStone(watch.productDetails = watch)}</h5>
                                                            </p>
                                                            <h4 className="font-14 black-3B fb"> ${watch && watch.price && numberWithCommas(parseFloat(watch.price).toFixed(2))} /ct</h4>
                                                            <p className="font-14 black-3B fm mb-2">{CompanyNameDisplay(watch)} <span className="text-nowrap" style={{ display: 'inline-block', float: 'right' }}><i style={{ color: "#003B75" }} className="fa fa-star"></i> {RatingDisplay('list', watch.average_rating, watch.total_rating)} </span></p>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        )
                                    })
                                    :
                                    <div>
                                        <FormattedMessage id="ProductNotFound" defaultMessage="Product not Found" />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="table_pagination">
                            <ReactPaginate
                                previousLabel={<i className="icon icon-chevron_gray-left"></i>}
                                nextLabel={<i className="icon icon-chevron_black"></i>}
                                pageCount={pageCount}
                                onPageChange={handlePageChange}
                                containerClassName={"paginationBttns"}
                                previousLinkClassName={"previousBttn"}
                                nextLinkClassName={"nextBttn"}
                                disabledClassName={"paginationDisabled"}
                                activeClassName={"paginationActive"}
                                forcePage={props?.pageReset}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {
                <PopupConfirm
                    message={popUpLimitMessage}
                    title={popUpLimitTitle}
                    handleResForm={handleResForm}
                />
            }
        </Fragment>
    )
}

export default ColorStone

